import * as React from "react";

import {
  Bus,
  Car,
  ConcreteMixer,
  FlatDeckTrailer,
  Forklift,
  LongerTrailer,
  Pickup,
  PrimeMover,
  RefrigeratedRailCar,
  RefrigeratedTrailer,
  RefrigeratedTruck,
  RubbishTruck,
  ShorterTrailer,
  TankerTrailer,
  TipTruck,
  Trailer,
  Van,
} from "..";
import VehicleType from "../types";

interface DeprecatedVehicleMarkerProps extends React.SVGProps<SVGSVGElement> {
  vehicleType: VehicleType;
  rotation?: number;
  moving?: boolean;
  on?: boolean;
  oldData?: boolean;
  pulse?: boolean;
}

/**
 * @deprecated
 */
export const getVehicleType = (
  vehicleType: VehicleType,
  fill: string,
  props?: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  switch (vehicleType) {
    case VehicleType.Bus:
      return <Bus fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.Car:
      return <Car fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.ConcreteMixer:
      return <ConcreteMixer fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.FlatDeckTrailer:
      return <FlatDeckTrailer fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.Forklift:
      return <Forklift fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.LongerTrailer:
      return <LongerTrailer fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.Pickup:
      return <Pickup fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.PrimeMover:
      return <PrimeMover fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.RefrigeratedRailCar:
      return <RefrigeratedRailCar fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.RefrigeratedTrailer:
      return <RefrigeratedTrailer fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.RefrigeratedTruck:
      return <RefrigeratedTruck fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.RubbishTruck:
      return <RubbishTruck fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.ShorterTrailer:
      return <ShorterTrailer fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.TipTruck:
      return <TipTruck fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.Trailer:
      return <Trailer fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.TankerTrailer:
      return <TankerTrailer fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    case VehicleType.Van:
      return <Van fill={fill} xmlns="http://www.w3.org/2000/svg" {...props} />;
    default:
      return <></>;
  }
};

/**
 * @deprecated
 */
function VehicleMarker(props: DeprecatedVehicleMarkerProps): React.ReactElement {
  const { vehicleType, moving, on, oldData, rotation, pulse, fill, ...svgProps } = props;
  let rotate;
  if (rotation && rotation > 0 && rotation <= 360) {
    rotate = `rotate(${+rotation} 26.5 24.5)`;
  }
  return (
    <svg viewBox={`0 0 ${53} ${53}`} width={53} height={53} opacity={oldData ? 0.5 : 1} fill="none" {...svgProps}>
      {on ? (
        <g>
          <circle cx="26.5" cy="24.5" r="13.5" fill={fill ?? "#0DA6FD"} fillOpacity="0.2">
            {pulse && (
              <>
                <animate
                  attributeType="SVG"
                  attributeName="r"
                  begin="0s"
                  dur="1.5s"
                  repeatCount="indefinite"
                  from="10%"
                  to="30%"
                />
                <animate
                  attributeType="CSS"
                  attributeName="stroke-width"
                  begin="0s"
                  dur="1.5s"
                  repeatCount="indefinite"
                  from="5%"
                  to="0%"
                />
                <animate
                  attributeType="CSS"
                  attributeName="opacity"
                  begin="0s"
                  dur="1.5s"
                  repeatCount="indefinite"
                  from="1"
                  to="0.2"
                />
              </>
            )}
          </circle>
          <circle cx="26.5" cy="24.5" r="9.5" fill="white" />
          <circle cx="26.5" cy="24.5" r="10.5" stroke="white" strokeOpacity="0.4" strokeWidth="2" />
          <g transform="translate(20,18)">{getVehicleType(vehicleType, "#7D8696")}</g>
          <g transform={rotate}>{moving && on && <path d="M21 8L26 0L31 8L26 5.5L21 8Z" fill={fill ?? "#0DA6FD"} />}</g>
        </g>
      ) : (
        <>
          <rect x="18" y="18" width="13" height="13" fill="#FFF" />
          <rect
            x="17"
            y="17"
            width="15"
            height="15"
            fill="#FFF"
            stroke={fill ?? "#0DA6FD"}
            strokeOpacity="0.5"
            strokeWidth="2"
          />
          <g transform="translate(19,19) scale(0.85)">{getVehicleType(vehicleType, "#7D8696")}</g>
        </>
      )}
    </svg>
  );
}

export default VehicleMarker;
